import Box from "@mui/material/Box";
import UploadGroupOfMaterialFileForm from "../../../components/UI/cloud/UploadGroupOfMaterialFileForm";
import AdminMaterialCloudFileService from "../../../API/material-cloud/admin/AdminMaterialCloudFileService";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import React, {useState} from "react";
import {constantsErrorMessages} from "../../../Constants";

const SettingsCloudLoadGroupMaterial = () => {
    const [alertData, setAlertData] = useState({});

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <div>

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '3px'
            }}>
                <UploadGroupOfMaterialFileForm
                    label={'Отправить'}
                    downloadFile={AdminMaterialCloudFileService.downloadGroupFile}
                    handleModalAlert={handleModalAlert}
                />
            </Box>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </div>
    );
};

export default SettingsCloudLoadGroupMaterial;